import { getCookieValue } from './getCookieValue'

export const getUserSegmentFromCookie = (): number => {
  // akaas_limelight_development_user_segments=2147483647~rv=19~id=4a6e33837116f319555d731cd5212df1~rn=user_segment_rest_19
  const userSegmentCookieDev = getCookieValue(document.cookie, 'akaas_limelight_development_user_segments')
  const userSegmentCookieQas = getCookieValue(document.cookie, 'akaas_limelight_staging_user_segments')
  const userSegmentCookieProd = getCookieValue(document.cookie, 'akaas_limelight_production_user_segments')
  const id = /~rv=(\d+)/g.exec(userSegmentCookieDev || userSegmentCookieQas || userSegmentCookieProd || '')?.[1] ?? '1'
  return parseInt(id, 10)
}
